import { DatePipe } from '@angular/common';
import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { IMessagesTasksInbox } from 'src/app/models/IMessagesTasksInbox';
import { MessageInbox } from 'src/app/models/IMessaging';
import { IPersonalInfo } from 'src/app/models/IPersonalInfo';
import { PatientSearchComponent } from 'src/app/patient-search/patient-search.component';
import { TasksAndGroupsService } from 'src/app/Services/TaskAndGroup/tasks-and-groups.service';
import { SharedService } from 'src/app/Sharedservice/SharedService';
declare let $: any;
@Component({
  selector: 'app-patient-secure-messages',
  templateUrl: './patient-secure-messages.component.html',
  styleUrls: ['./patient-secure-messages.component.css']
})
export class PatientSecureMessagesComponent implements OnInit {
  PatientSecureMessageForm: FormGroup;
  constructor(private fb: FormBuilder, public dialog: MatDialog, private datePipe: DatePipe
    , private spinner: NgxSpinnerService,
    public dialogRef: MatDialogRef<any>
    , private toastr: ToastrService, private dateservice: SharedService
    , private _taskandgroupservice: TasksAndGroupsService, @Inject(MAT_DIALOG_DATA) public data: any,) { }
  fromUserName: string = "";
  secureMessageText: string = "";
  IsSingleClickedBtn: boolean = false;
  ngOnInit() {

    this.PatientSecureMessageForm = this.fb.group({
      patientName: ['', Validators.required],
      subject: ['', Validators.required],
      txtMessage: ['', Validators.required],
    });
    if (this.data.Type == 'SentBox') {
      this.IsSingleClickedBtn = true;
      this.PatientSecureMessageForm.patchValue({
        patientName: this.data.ele.patientName,
        subject: this.data.ele.subject,
        txtMessage: this.data.ele.notes,
      })

      this.fromUserName = sessionStorage.getItem("username")
      this.secureMessageText = 'Secure Message Information'
      var characterCount = this.data.ele.notes.length,
        current = $('#current'),
        maximum = $('#maximum'),
        theCount = $('#the-count');
      current.text(characterCount);
    } else {
      this.IsSingleClickedBtn = false;
      this.fromUserName = sessionStorage.getItem("username")
      this.secureMessageText = "Create New Secure Message";
      $('textarea').keyup(function () {
        var characterCount = $(this).val().length,
          current = $('#current'),
          maximum = $('#maximum'),
          theCount = $('#the-count');
        current.text(characterCount);
      });
      /*This isn't entirely necessary, just playin around*/
      if (characterCount < 70) {
        current.css('color', '#666');
      }
      if (characterCount > 70 && characterCount < 90) {
        current.css('color', '#6d5555');
      }
      if (characterCount > 90 && characterCount < 100) {
        current.css('color', '#793535');
      }
      if (characterCount > 100 && characterCount < 120) {
        current.css('color', '#841c1c');
      }
      if (characterCount > 120 && characterCount < 139) {
        current.css('color', '#8f0001');
      }

      if (characterCount >= 140) {
        maximum.css('color', '#8f0001');
        current.css('color', '#8f0001');
        theCount.css('font-weight', 'bold');
      } else {
        maximum.css('color', '#666');
        theCount.css('font-weight', 'normal');
      }
    }
    this.getAllSecureMessages();
  }
  getAllSecureMessages() {
    this._taskandgroupservice.getAllSecureMessages(0, 'PortalRequest').subscribe((data: MessageInbox[]) => {

    },
      (err: any) => console.log(err)
    );
  }
  _msgtask: IMessagesTasksInbox;
  CreateMessage() {

    if (this.PatientSecureMessageForm.value.txtMessage == "") {
      this.toastr.error("Please Enter Message Text.")
      return false;
    } if (this.PatientSecureMessageForm.value.subject == "") {
      this.toastr.error("Please Enter Subject.")
      return false;
    }
    this._msgtask = new IMessagesTasksInbox();
    this._msgtask.FromUserId = encodeURIComponent(sessionStorage.getItem("userId"));
    this._msgtask.PatientId = this.searchPatientId;
    this._msgtask.PatientName = this.searchPatName;
    this._msgtask.Subject = this.PatientSecureMessageForm.value.subject;
    this._msgtask.Note = this.PatientSecureMessageForm.value.txtMessage;
    this._msgtask.CreatedBy = encodeURIComponent(sessionStorage.getItem("userId"));
    this._msgtask.LocationId = Number(sessionStorage.getItem("LocationId"));
    this._msgtask.FacilityId = Number(sessionStorage.getItem("FacilityId"));
    this._msgtask.TypeOfMessage = 'Provider';

    this._taskandgroupservice.SaveSecureMessageInfo(this._msgtask).subscribe(data => {
      this.dialogRef.close(true);
      this.toastr.success(data)

    },
      (err: any) => {
        this.spinner.hide();
        console.log(err);
      }
    )
  }
  patientInformation: IPersonalInfo;
  searchPatientId: number = 0;
  searchPatName: string = '';
  onClickPatientSearch() {
    sessionStorage.setItem("ispatSerachPopup", "True");
    const dialogRef = this.dialog.open(PatientSearchComponent, {
      width: 'auto',
      data: { action: true }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result != undefined && result != '') {
        this.patientInformation = result;
        this.searchPatientId = this.patientInformation.patientId;
        this.searchPatName = this.patientInformation.name + '  ( ' + (this.transform(this.patientInformation.dob) + ' )');
        this.PatientSecureMessageForm.patchValue({
          patientName: this.patientInformation.name + '  ( ' + (this.transform(this.patientInformation.dob) + ' )')//patDOB patientId //dPatId
        })
      }
    });
  }
  transform(value: string): string {
    if (value && value != undefined) {
      var datePipe = new DatePipe("en-US");
      value = datePipe.transform(value, 'MM/dd/yyyy');
    }
    return value;
  }
  CloseDailog() {
    this.dialogRef.close(false);
  }
}
